import { SplitCategoryAsObjectType } from "../../../types/split-category-type";
import { CategoryView } from "../../../view/category/category.view";
import { SplitCategory } from "./split-category";
import { CategoryUtils } from "@bitwarden/web-vault/app/models/view/category/category.utils";

export class SplitCategoryFactory {
  static createFromSplitCategoryObject(obj: SplitCategoryAsObjectType): SplitCategory {
    const splitCategory = new SplitCategory();
    splitCategory.categoryLink.id = obj.ctId;
    splitCategory.weight = obj.wgt;
    splitCategory.roundingDefault = obj.rdf;
    return splitCategory;
  }

  static createFromSplitCategoryObjectArray(
    splitCatObjects: SplitCategoryAsObjectType[],
    useDefault = false,
  ): SplitCategory[] {
    if (splitCatObjects && splitCatObjects.length > 0) {
      return splitCatObjects.map((splitCatObj) => this.createFromSplitCategoryObject(splitCatObj));
    } else {
      if (useDefault) {
        return SplitCategoryFactory.createFromCategoryViewArray([
          CategoryUtils.getDefaultCategoryView(),
        ]);
      } else {
        return [];
      }
    }
  }

  static createFromCategoryView(category: CategoryView, roundingDefault = false): SplitCategory {
    const splitCategory = new SplitCategory();
    splitCategory.categoryLink.id = category.id;
    splitCategory.roundingDefault = roundingDefault;
    return splitCategory;
  }

  static createFromCategoryViewArray(
    categories: CategoryView[],
    defaultRoundingIndex = 0,
  ): SplitCategory[] {
    const splitCategories = categories.map((category, index) =>
      this.createFromCategoryView(category),
    );

    if (splitCategories?.[defaultRoundingIndex]) {
      splitCategories[defaultRoundingIndex].roundingDefault = true;
    }

    return splitCategories;
  }

  static createFromSplitCategory(splitCategory: SplitCategory): SplitCategory {
    const newSplitCategory = new SplitCategory();
    newSplitCategory.categoryLink.id = splitCategory.categoryLink.id;
    newSplitCategory.weight = splitCategory.weight;
    newSplitCategory.roundingDefault = splitCategory.roundingDefault;
    return newSplitCategory;
  }

  // use this function when creating from an object that was once a GlossDateAbstraction.
  // This might be when we have passed the object through a web worker so that the original class
  // methods are not available.
  static createFromAnyObject(obj: any): SplitCategory {
    const splitCatAsObject: SplitCategoryAsObjectType = {
      ctId: obj?.categoryLink?.id ? obj.categoryLink.id : "",
      wgt: obj?.weight || 1,
      rdf: obj?.roundingDefault || false,
    };
    return this.createFromSplitCategoryObject(splitCatAsObject);
  }

  static createFromAnyObjectArray(objs: any[]): SplitCategory[] {
    if (objs && objs.length > 0) {
      return objs.map((obj) => this.createFromAnyObject(obj));
    } else {
      return [];
    }
  }
}
